import React, { useMemo } from 'react';
import { parseInline, parsePageContent } from '../lib/pageContent';

// Footer içerik sayfalarının gövdesi. Aynı bileşen hem oyuncu sayfasında
// (pages/FooterPage.jsx) hem panelin canlı önizlemesinde (admin/FooterPages)
// çizilir: önizleme ayrı yazılsaydı yönetici kaydettikten sonra başka bir
// sayfa görürdü.
//
// Metin `dangerouslySetInnerHTML` ile basılmaz; bloklar React düğümüdür.

const Inline = ({ text }) => (
  <>
    {parseInline(text).map((part, index) => {
      const key = `${part.type}-${index}`;
      if (part.type === 'link') {
        const external = !part.href.startsWith('mailto:');
        return (
          <a
            key={key}
            href={part.href}
            {...(external ? { target: '_blank', rel: 'noreferrer' } : {})}
            className="text-[#3cc487] underline decoration-[#3cc487]/40 underline-offset-2 hover:decoration-[#3cc487] break-words"
          >
            {part.text}
          </a>
        );
      }
      return part.bold
        ? <strong key={key} className="font-semibold text-slate-100">{part.text}</strong>
        : <React.Fragment key={key}>{part.text}</React.Fragment>;
    })}
  </>
);

const PageContent = ({ content, compact = false }) => {
  const blocks = useMemo(() => parsePageContent(content), [content]);
  if (!blocks.length) return null;

  return (
    <div className={compact ? 'space-y-3' : 'space-y-5'}>
      {blocks.map((block, index) => {
        const key = `${block.type}-${index}`;
        if (block.type === 'heading') {
          return block.level === 2 ? (
            <h2
              key={key}
              className={`font-black text-slate-100 ${compact ? 'text-base pt-2' : 'text-lg md:text-xl pt-3'}`}
            >
              <Inline text={block.text} />
            </h2>
          ) : (
            <h3
              key={key}
              className={`font-bold text-slate-200 ${compact ? 'text-sm pt-1' : 'text-base pt-2'}`}
            >
              <Inline text={block.text} />
            </h3>
          );
        }
        if (block.type === 'list') {
          const Tag = block.ordered ? 'ol' : 'ul';
          return (
            <Tag
              key={key}
              className={`${block.ordered ? 'list-decimal' : 'list-disc'} pl-5 space-y-1.5 marker:text-[#3cc487]`}
            >
              {block.items.map((item, itemIndex) => (
                <li key={`${key}-${itemIndex}`}>
                  <Inline text={item} />
                </li>
              ))}
            </Tag>
          );
        }
        return (
          <p key={key} className="whitespace-pre-line">
            <Inline text={block.text} />
          </p>
        );
      })}
    </div>
  );
};

export default PageContent;
